export const SET_INSTANT_EXPERIENCES = 'SET_INSTANT_EXPERIENCES';
export const FB_PIXEL_RESERVATION = 'FB_PIXEL_RESERVATION';
export const SET_INSTANT_EXPERIENCES_OWNER = 'SET_INSTANT_EXPERIENCES_OWNER';




// WEBPACK FOOTER //
// ./src/app/instantExperiences/constants.js